<template>
  <div class="bienvenida-page">
    <p class="versiculo-referencia-fija" ref="versiculoRef"> </p>

    <!-- Contenedor fecha -->
    <div class="fecha-evento" ref="fechaRef">
      <p class="fecha-gran-dia" ref="granDiaRef">Reserva la Fecha</p>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Sábado</p>
      <p class="fecha-dia-numero" ref="numeroRef">29</p>
      <p class="fecha-mes" ref="mesRef">AGOSTO</p>
      <p class="fecha-anio" ref="anioRef">2026</p>
    </div>

    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
        <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
            Hace quince años nacio una hermosa niña 
            <br>enviada por Dios para ser criada y formada como el más grande tesoro. <br>
<br>
Hay momentos en la vida que
imaginamos,

soñamos y esperamos.    <br><br>
                      
           Uno de esos momentos ha llegado.      <br><br>
           Será un honor contar con su presencia.
            <br>
          </p>
        </div>
      </div>
    </div>

    <!-- Grupo decorativo 1 (Con Rama Larga) -->
    <div class="disco-group disco1-group">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa" ref="rama1Ref" />
      <img src="@/assets/monio.png" alt="disco" class="disco" ref="disco1Ref" />
    </div>

    <!-- Grupo decorativo 2 (Con Rama Larga) -->
    <div class="disco-group disco2-group">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa" ref="rama2Ref" />
      <img src="@/assets/monio.png" alt="disco" class="disco" ref="disco2Ref" />
    </div>

    <!-- Grupo decorativo 3 -->
    <div class="disco-group disco3-group">
      <img src="@/assets/mari.png" alt="disco" class="disco" ref="disco3Ref" />
    </div>
  </div>
</template>
<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref('');
    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);
    const rama1Ref = ref(null);
    const rama2Ref = ref(null);

    let observer = null;

    // Un solo observador centralizado con respuesta rápida (threshold 0.05)
    const setupObserver = () => {
      const options = {
        threshold: 0.05,
        rootMargin: '0px 0px -30px 0px'
      };

      // Mapeo de elementos a sus animaciones
      const targets = new Map();

      const addTarget = (el, animFn) => {
        if (el) targets.set(el, animFn);
      };

      // Animaciones de texto fluidas y livianas
      addTarget(granDiaRef.value, () => gsap.fromTo(granDiaRef.value, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power1.out' }));
      addTarget(diaSemanaRef.value, () => gsap.fromTo(diaSemanaRef.value, { autoAlpha: 0, y: 15 }, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power1.out' }));
      
      // Reemplazado 'bounce.out' pesado por una curva 'back.out' mucho más eficiente
      addTarget(numeroRef.value, () => gsap.fromTo(numeroRef.value, { autoAlpha: 0, y: -40, scale: 0.8 }, { autoAlpha: 1, y: 0, scale: 1, duration: 0.8, ease: 'back.out(1.4)', force3D: true }));
      
      addTarget(mesRef.value, () => gsap.fromTo(mesRef.value, { autoAlpha: 0, y: 15 }, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power1.out' }));
      addTarget(anioRef.value, () => gsap.fromTo(anioRef.value, { autoAlpha: 0, y: 15 }, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power1.out' }));
      addTarget(mensajeRef.value, () => gsap.fromTo(mensajeRef.value, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power1.out' }));
      addTarget(versiculoTextRef.value, () => gsap.fromTo(versiculoTextRef.value, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power1.out' }));

      // Combo Flor + Rama optimizado (sustituido 'elastic.out' por 'back.out' rápido)
      const animarCombo = (discoEl, ramaEl, delay = 0) => {
        const tl = gsap.timeline({ delay });
        tl.fromTo(discoEl, 
          { autoAlpha: 0, rotate: -15, scale: 0.7 }, 
          { autoAlpha: 1, rotate: 0, scale: 1, duration: 0.8, ease: 'power2.out', force3D: true }
        );
        if (ramaEl) {
          tl.fromTo(ramaEl, 
            { autoAlpha: 0, scale: 0, transformOrigin: 'center center' }, 
            { autoAlpha: 1, scale: 1, duration: 0.8, ease: 'back.out(1.2)', force3D: true }, 
            '-=0.4'
          );
        }
      };

      addTarget(disco1Ref.value, () => animarCombo(disco1Ref.value, rama1Ref.value));
      addTarget(disco2Ref.value, () => animarCombo(disco2Ref.value, rama2Ref.value, 0.1));
      addTarget(disco3Ref.value, () => animarCombo(disco3Ref.value, null, 0.2));

      // Crear el IntersectionObserver único
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const animFn = targets.get(entry.target);
            if (animFn) {
              animFn();
              observer.unobserve(entry.target);
            }
          }
        });
      }, options);

      // Observar únicamente los elementos registrados
      targets.forEach((_, el) => observer.observe(el));
    };

    onMounted(async () => {
      await nextTick();
      setupObserver();
    });

    onUnmounted(() => {
      if (observer) observer.disconnect();
    });

    return {
      mensaje, granDiaRef, diaSemanaRef, numeroRef, mesRef, anioRef,
      mensajeRef, versiculoTextRef, versiculoRef, disco1Ref, disco2Ref, disco3Ref,
      rama1Ref, rama2Ref
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  background: transparent;
  color: black;
  min-height: 80vh;
  padding: 30px 20px;
  margin-top:0px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden; /* Para que las ramas largas no den problemas */
}

/* Fecha Estilo Dorado */
.fecha-evento {
  text-align: center;
  margin: 60px 0 40px;
  position: relative;
  z-index: 5;
}
.fecha-gran-dia, .fecha-dia-semana, .fecha-dia-numero, .fecha-mes, .fecha-anio {
  background: linear-gradient(110deg, #e6a6c6 30%, #ff85ae 45%, #faadd8 50%, #ff85c2 55%, #ef90ae 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 1px 1px rgba(0,0,0,0.3));
  display: block;
  margin: 0 auto;
}

.fecha-gran-dia { font-family: 'CynthiaJuneJF', cursive; font-size: 45px !important; }
.fecha-dia-semana { font-family: 'fecha', serif; font-size: 29px; margin: 10px 0; }
.fecha-dia-numero { font-family: 'fecha', serif; font-size: 72px !important; font-weight: bold; }
.fecha-mes { font-family: 'Playfair Display', serif; font-size: 26px; font-weight: 600; letter-spacing: 2px; }
.fecha-anio { font-family: 'Poppins', sans-serif; font-size: 16px; font-style: italic; }

/* Contenido */
.bienvenida-container { display: flex; flex-direction: column; align-items: center; }
.mensaje-bienvenida { font: 300 19px 'Josefin Sans', sans-serif; color: #000; text-align: center; line-height: 2; }
.versiculo-container { margin: -20px 20px 0; text-align: center; }
.versiculo-texto { font: 18px 'quote', sans-serif; line-height: 1.8; color: #333; }
.letra-quince {
  padding-right: 5px;
  font-family: 'CynthiaJuneJF', cursive; font-size: 54px;
  background: linear-gradient(110deg, #8a6d3b 0%, #bf953f 20%, #6e6b3b 50%, #bf953f 80%, #8a6d3b 100%);
  -webkit-background-clip: text; background-clip: text; color: transparent;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.3));
}

/* Decoraciones */
.disco-group {
  position: absolute;
  pointer-events: none;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disco {
  width: 150px;
  height: auto;
  position: relative;
  z-index: 2; /* Flor al frente */
}

.rama-decorativa {
  position: absolute;
  width: 270px; /* Rama más larga que la flor */
  height: auto;
  margin-top:100px;
  z-index: 1; /* Rama atrás */
  opacity: 0;
  filter: brightness(1.1); /* Toque deasas luz */
}

/* Posiciones */
.disco1-group { top: 0%; right: -12%; width: 150px !important;  z-index:10 !important;}
.disco2-group { top: 25%; left: -8%; width: 120px; }
.disco3-group { bottom: -5%; left: -22%; z-index:10; width: 150px !important;}
</style>